/* eslint-disable max-len */

import { Component } from 'react';

import { warrior } from '../../../constants/color';
import { G, Path, Svg } from '../../../utils/packages/reactNativeSvg';

const DEFAULT_SVG_SIZE = 20;

interface Props {
  size?: number;
  fillColor?: string;
}

interface DefaultProps {
  size: number;
  fillColor: string;
}

type PropsWithDefaults = Props & DefaultProps;

export default class IconShopMore extends Component<Props> {
  static defaultProps: DefaultProps = {
    size: DEFAULT_SVG_SIZE,
    fillColor: warrior,
  };

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { size, fillColor } = this.props as PropsWithDefaults;
    const sizeString = size.toString();

    return (
      <Svg
        width={size}
        height={size}
        viewBox={`0 0 ${sizeString} ${sizeString}`}
      >
        <G stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <G
            transform="translate(-312.000000, -972.000000)"
            fill={fillColor}
            fillRule="nonzero"
          >
            <G transform="translate(-2252.000000, 842.000000)">
              <G transform="translate(0.000000, 15.000000)">
                <G transform="translate(2552.000000, 115.000000)">
                  <G transform="translate(12.000000, 0.000000)">
                    <Path d="M10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 Z M10,19 C5.02943725,19 1,14.9705627 1,10 C1,5.02943725 5.02943725,1 10,1 C14.9705627,1 19,5.02943725 19,10 C19,14.9705627 14.9705627,19 10,19 Z" />
                    <G transform="translate(4.555556, 5.666667)">
                      <Path d="M1,4.83333333 L9.88888889,4.83333333 C10.1650313,4.83333333 10.3888889,4.60947571 10.3888889,4.33333333 C10.3888889,4.05719096 10.1650313,3.83333333 9.88888889,3.83333333 L1,3.83333333 C0.723857625,3.83333333 0.5,4.05719096 0.5,4.33333333 C0.5,4.60947571 0.723857625,4.83333333 1,4.83333333 Z" />
                      <Path d="M6.54639164,7.34116133 C6.36662001,7.55077232 6.39080959,7.86642932 6.60042059,8.04620095 C6.81003158,8.22597259 7.12568858,8.201783 7.30546021,7.99217201 L10.2684232,4.53740217 C10.4335238,4.3448973 10.4283549,4.05927701 10.2563969,3.87287201 L7.29343398,0.660975178 C7.10619574,0.458006084 6.7898702,0.445253707 6.5869011,0.632491946 C6.38393201,0.819730185 6.37117963,1.13605573 6.55841787,1.33902482 L9.21980192,4.22400553 L6.54639164,7.34116133 Z" />
                    </G>
                  </G>
                </G>
              </G>
            </G>
          </G>
        </G>
      </Svg>
    );
  }
}
